import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <Link to="/" style={{ color: '#61dafb', textDecoration: 'none', marginBottom: '20px', display: 'inline-block' }}>
        ← Back to Home
      </Link>
      
      <h1>Terms of Service</h1>
      <p><em>Last updated: December 12, 2025</em></p>

      <section style={{ marginTop: '30px', lineHeight: '1.8' }}>
        <p>
          Client is the covered entity and authorizes workforce users and permitted uses.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          We act as a business associate/subcontractor and process PHI only to provide the service as permitted by the BAA.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          User access must be role-based; shared accounts prohibited; MFA required.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          Exports of PHI must follow the client's policies; no copying PHI into non-approved tools.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          BAA governs PHI handling and overrides conflicting terms.
        </p>
      </section>

      <div style={{ marginTop: '50px', paddingTop: '20px', borderTop: '1px solid #ddd' }}>
        <Link to="/legal/privacy" style={{ color: '#61dafb', textDecoration: 'none' }}>
          View Privacy Policy →
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;
